<app-nav titulo="Detalles del Contrato" descripcion="">

    <div class="form-step">

        <div class="summary-container" *ngIf="contratoDTO">
            <h4>Resumen del Contrato</h4>

            <!-- Sección Propiedad -->
            <div class="summary-section">
                <h5>Propiedad</h5>
                <div class="summary-item">
                    <span class="label">Ubicación:</span>
                    <span class="value">{{ contratoDTO.propiedad?.domicilio }}</span>
                </div>
            </div>
            <!-- Sección Datos Generales -->
            <div class="summary-section">
                <h5>Información General</h5>
                <div class="summary-grid">
                    <div class="summary-item">
                        <span class="label">Fecha de Firma:</span>
                        <span class="value">{{ contratoDTO.fechaFirma | date }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Ciudad:</span>
                        <span class="value">{{ contratoDTO.ciudadFirma }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Plazo:</span>
                        <span class="value">{{ contratoDTO.plazoContrato }} meses</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Tipo de Inmueble:</span>
                        <span class="value">{{ contratoDTO.tipoInmueble | titlecase }}</span>
                    </div>
                </div>
            </div>

            <!-- Sección Datos Monetarios -->
            <div class="summary-section">
                <h5>Datos Monetarios</h5>
                <div class="summary-grid">
                    <div class="summary-item">
                        <span class="label">Alquiler Mensual:</span>
                        <span class="value">${{ contratoDTO.alquiler?.monto | number }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Moneda:</span>
                        <span class="value">{{ contratoDTO.monedaPago === 'pesos' ? 'Pesos Argentinos' :
                            'Dólares' }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Tipo de Ajuste:</span>
                        <span class="value">{{ contratoDTO.tipoAjuste === 'ninguno' ? 'Sin ajuste' : 'Con
                            ajuste' }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Depósito de Garantía:</span>
                        <span class="value">${{ contratoDTO.montoDepositoGarantia | number }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Modalidad:</span>
                        <span class="value">{{ getFormaDePagoLabel(contratoDTO.formaDePago) }}</span>
                    </div>
                </div>
            </div>
            <!-- Sección Personas -->
            <div class="summary-section">
                <h5>Partes del Contrato</h5>
                <div class="row">
                    <div class="col-md-6">
                        <h6>Propietarios</h6>
                        <div class="persons-list">
                            <div *ngFor="let prop of contratoDTO.propietarios" class="person-item">
                                <div class="person-name">{{ prop.nombre }}</div>
                                <div class="person-details">
                                    DNI: {{ prop.documento }} | CUIT: {{ prop.cuit || 'No especificado' }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h6>Inquilinos</h6>
                        <div class="persons-list">
                            <div *ngFor="let inq of contratoDTO.inquilinos" class="person-item">
                                <div class="person-name">{{ inq.nombre }}</div>
                                <div class="person-details">
                                    DNI: {{ inq.documento }} | CUIT: {{ inq.cuit || 'No especificado' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Botones de Acción -->
        <div class="action-buttons-section">
            <!-- Estado: Después de generar contrato -->
            <div class="contract-success">

                <div class="download-buttons">
                    <button mat-raised-button color="primary" type="button" (click)="downloadPDF()">
                        Descargar PDF
                    </button>

                    <button mat-raised-button color="accent" type="button" (click)="downloadDOCX()">
                        Descargar DOCX
                    </button>
                    <button mat-raised-button color="warn" routerLink="/contratos">
                        Volver
                    </button>

                </div>
            </div>
        </div>


    </div>

</app-nav>